
export const roomDetailsBookNowButton = {
    name: 'roomdetailsbooknowbutton',
    inserted: (el) => {
        let elemSelec = document.getElementById("bedTypes");

        let value = elemSelec[0].innerText;

        let elemTop = document.getElementById("room-detail-bed-type-top");
        let elemBottom = document.getElementById("room-detail-bed-type-bottom");

        if(elemTop) {
          elemTop.innerHTML = value
          elemTop.classList.toggle("no-value", !value);
        }

        if(elemBottom) elemBottom.innerHTML = value;

        let updateTagsFn = function(e) {

            value = e.target.options[e.target.selectedIndex].innerText;

            if(elemTop) elemTop.innerHTML = value;
            if(elemBottom) elemBottom.innerHTML = value;
        }

        elemSelec.addEventListener("change", updateTagsFn)


    }
}
